import { sub, differenceInMilliseconds } from "date-fns";
import { CertificateStatus } from "type/certificateType";

export const getCertificateStatus = (date: string): CertificateStatus => {
  const endDate = new Date(date);
  const msDifference = differenceInMilliseconds(endDate, new Date());
  const daysDifference = msDifference / (1000 * 60 * 60 * 24); // 밀리초를 일 단위로 변환

  if (daysDifference < 0) {
    // 인증서 만료 후 30일 이내 : 갱신 유예 기간(GRACE_PERIOD)
    // 인증서 만료일 이후 30일 이후 : 만료(EXPIRE)
    const gracePeriodDate = sub(endDate, { days: -30 });
    const gracePeriodMsDifference = differenceInMilliseconds(
      gracePeriodDate,
      new Date()
    );
    const gracePeriodDaysDifference =
      gracePeriodMsDifference / (1000 * 60 * 60 * 24);

    if (gracePeriodDaysDifference > 0) {
      return "GRACE_PERIOD";
    }
    return "EXPIRE";
  } else {
    // 인증서 만료일 60일 이내 : 갱신필요(만료임박) (NEED_RENEW)
    const needRenewDate = sub(endDate, { days: 60 });
    const needRenewMsDifference = differenceInMilliseconds(
      needRenewDate,
      new Date()
    );
    const needRenewDaysDifference =
      needRenewMsDifference / (1000 * 60 * 60 * 24);

    if (needRenewDaysDifference < 0) {
      return "NEED_RENEW";
    }
    return "ACTIVE";
  }
};

export const getCertificateStatusName = (status: CertificateStatus) => {
  switch (status) {
    case "EXPIRE":
      return "만료";
    case "GRACE_PERIOD":
      return "갱신유예";
    case "NEED_RENEW":
      return "갱신필요";
    case "ACTIVE":
      return "연동";
  }
};
